import React from 'react';
import * as wpsdb from '../sparks/wipdb.json';

const initVal = {
    tags: { Participant: [], Occasion: [], Interests: [] },
};

export const SparkManagerContext = React.createContext(initVal);

export function SparkManagerProvider({ children }) {
   
    const [tags, setTags] = React.useState(initVal.tags);

    async function getData() {        
        const tags = await getMicroexperienceTags();
        setTags(tags);      
    }    

    async function getMicroexperienceTags() {
        return new Promise((resolve, reject) => {
            resolve(wpsdb.Tags);
        });
    }

    React.useEffect(() => {
        // load inital data
        getData();
    });

    const reloadDataAsync = async () => {
        return await getData();
    }

    const value = { tags, reloadDataAsync };
    return <SparkManagerContext.Provider value={value}>{children}</SparkManagerContext.Provider>;
}
